@let items = (serviceCenters$ | async) ?? [];

<lib-multiselect
  titleTranslationKey="monitoring.service-center"
  chosenTranslationKey="monitoring.service-centers-chosen"
  [options]="items"
  [formControl]="controlEntity"
  [isSearchDisplayed]="true"
  [isLazyLoading]="serviceCenterDictionaryService.loadingState() === LoadingState.LOADING"
  (shouldLoadMoreOptions)="loadMore()"
  (keywordChange)="onKeywordChange($event)"
/>
